import type { IllustrationKey, SlopeDifficulty, SlopeMode } from './types';

function toDifficulty(slope: number, easyMax: number, struggleMax: number): SlopeDifficulty {
  if (slope < easyMax) return 'easy';
  if (slope < struggleMax) return 'struggle';
  return 'impossible';
}

/** Mod + eğim → illüstrasyon anahtarı */
export function getIllustrationKeyForMode(slope: number | null | undefined, mode: SlopeMode): IllustrationKey {
  const s = Number(slope);
  if (!Number.isFinite(s)) {
    return mode === 'walking' ? 'walking_easy' : mode === 'car' ? 'car_easy' : 'tractor_easy';
  }

  if (mode === 'walking') {
    const d = toDifficulty(s, 10, 30);
    return `walking_${d === 'struggle' ? 'struggle' : d}` as IllustrationKey;
  }
  if (mode === 'car') {
    const d = toDifficulty(s, 15, 38);
    return `car_${d === 'struggle' ? 'struggle' : d}` as IllustrationKey;
  }
  const d = toDifficulty(s, 22, 35);
  return `tractor_${d === 'struggle' ? 'struggle' : d}` as IllustrationKey;
}

/**
 * Eğim görsel kartındaki ana illüstrasyon — mevcut getSlopeInfo eşikleriyle uyumlu.
 * Düşük eğimde yürüyüş, orta-üstte araç, çok dikte iş makinesi limiti anlatılır.
 */
export function getPrimaryIllustrationKey(slope: number | null | undefined): IllustrationKey {
  const s = Number(slope);
  if (!Number.isFinite(s)) return 'walking_easy';
  if (s < 10) return 'walking_easy';
  if (s < 20) return 'walking_struggle';
  if (s < 30) return 'walking_impossible';
  if (s < 40) return 'car_impossible';
  return 'tractor_impossible';
}
